// extracted by mini-css-extract-plugin
export default {"note":"welcome-note_note__wUYC7"};